import Queue from "./Queue";

/**
 * @class
 * @inheritDoc
 * @extends Queue
 * @memberof module:media.module:loaders
 * @classdesc Синхронная очередь загрузки
 */
class SyncQueue extends Queue {

    constructor(...items) {
        super(...items);
    }

    loadNextItem() {
        let item = this.items.values().next();
        if (item && !item.done) {
            item.value.once('complete', this.loadNextItem, this);
            item.value.load();
        }
        this._handleProgress();
    }

    /**
     * Начать загрузку
     * @param {Boolean} [cache=true] - Использовать кеш ресурсов
     */
    load(cache = true) {
        this.loadNextItem();
    }
}

export default SyncQueue;
